import { subscribeStyles } from "@insite/content-library/Widgets/Basic/Subscribe";
import { formFieldSizeVariants } from "@store/theme/common/props/form";
import { css } from "styled-components";

subscribeStyles.emailButton = {
    css: css`
        min-height: ${formFieldSizeVariants.default.height}px;
    `,
};
